import React from 'react';
import FAQContentContainer from '../../Componant/FAQ';

const FAQContent = () => {
  return (
    <div className='page-body'>
      <FAQContentContainer />
    </div>
  );
};

export default FAQContent;
